module.exports = __webpack_public_path__ + "img/back.10b0dfd7.png";